import React from "react"

import { useUI } from "providers/UIProvider"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"

import { BOOKING_FEE_TABS, CANCELLATION_FEE_TABS } from "types/shared"

import Tabs from "components/UI/molecules/Tabs"

const CancellationFeeTabs: React.FC<any> = () => {
  const { T } = useUI()
  const {handleChangeCancelCommissionsTab, cancelCommissionsTabType } = useSettings()

  const handleTabChange = (val: BOOKING_FEE_TABS) => handleChangeCancelCommissionsTab(val)

  return (
    <Tabs 
      items={[
        {
          key: CANCELLATION_FEE_TABS.PERCENT,
          value: T("cancellation_fee.tabs.percent_title"),
          valueIcon: "bookingFee"
        },
        {
          key: CANCELLATION_FEE_TABS.FIXED,
          value: T("cancellation_fee.tabs.fixed_title"),
          valueIcon: "currency_GEL",
          renderContent: true,
          content: "₾"
        }
      ]}
      currentTab={cancelCommissionsTabType}
      handleTabChange={handleTabChange}
    />
  )
}

export default React.memo(CancellationFeeTabs)